module.exports = __webpack_public_path__ + "static/media/ic_arrow_next_blue.a7897957.svg";